import styled from '@emotion/styled';
// eslint-disable-next-line no-unused-vars
import { Anchor, Box, Breadcrumbs as MantineBreadcrumbs, BreadcrumbsProps, Text } from '@mantine/core';
import React from 'react';
import { Link } from 'react-router-dom';

import { fontSize } from '~/styles/mixins';

const Root = styled(Box)`
  * {
    ${fontSize('sm')}
  }
`;

/**
 * Wrapper molecule component for Mantine Breadcrumbs.
 * @param {{items: {title: string, path?: string}[]} & BreadcrumbsProps} props
 */
const Breadcrumbs = ({ items, ...rest }) => {
  const breadcrumbItems = items.map((item, index) =>
    index < items.length - 1 ? (
      <Anchor key={item.title} component={Link} to={item.path}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={item.title}>{item.title}</Text>
    ),
  );
  return (
    <Root>
      <MantineBreadcrumbs {...rest}>{breadcrumbItems}</MantineBreadcrumbs>
    </Root>
  );
};

export default Breadcrumbs;
